export default "__VITE_ASSET__486c59af__"